import { render, staticRenderFns } from "./Libs.vue?vue&type=template&id=6848bd8e&"
import script from "./Libs.vue?vue&type=script&lang=js&"
export * from "./Libs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports